import { render, staticRenderFns } from "./WardButtonPad.vue?vue&type=template&id=535b09ab&scoped=true&"
import script from "./WardButtonPad.vue?vue&type=script&lang=js&"
export * from "./WardButtonPad.vue?vue&type=script&lang=js&"
import style0 from "./WardButtonPad.vue?vue&type=style&index=0&id=535b09ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535b09ab",
  null
  
)

export default component.exports